import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Phone } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';

const SiteAlertModal = () => {
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState<{ title: string; message: string; phone: string } | null>(null);

  useEffect(() => {
    if (sessionStorage.getItem('site_alert_dismissed')) return;

    const fetchAlert = async () => {
      const { data } = await supabase
        .from('page_content')
        .select('content')
        .eq('page_slug', 'site_alerts')
        .maybeSingle();

      if (data?.content) {
        const c = data.content as Record<string, unknown>;
        if (c.enabled) {
          setAlert({
            title: (c.title as string) || 'Внимание',
            message: (c.message as string) || '',
            phone: (c.phone as string) || '',
          });
          setOpen(true);
        }
      }
    };

    fetchAlert();
  }, []);

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem('site_alert_dismissed', '1');
  };

  if (!alert) return null;

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            {alert.title}
          </DialogTitle>
          <DialogDescription className="text-base pt-2 whitespace-pre-line">
            {alert.message}
          </DialogDescription>
        </DialogHeader>
        {alert.phone && (
          <a
            href={`tel:${alert.phone}`}
            className="flex items-center justify-center gap-2 w-full py-3 rounded-lg bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors"
          >
            <Phone className="h-4 w-4" />
            {alert.phone}
          </a>
        )}
        <Button variant="outline" onClick={handleClose} className="w-full">
          Закрыть
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SiteAlertModal;
